import { Component, Input } from '@angular/core';
import { AyaSchoolTableView } from '../../models';
import { TableModule } from 'primeng/table';
import { PricePipe, SortByPipe } from '@lx/shared/ui/pipes';
import { NgClass, NgForOf, NgIf, NgTemplateOutlet } from '@angular/common';

@Component({
  standalone: true,
  selector: 'lx-price-lists-portal-aya-school-table',
  imports: [TableModule, PricePipe, SortByPipe, NgForOf, NgIf, NgClass, NgTemplateOutlet],
  templateUrl: './aya-school-table.component.html',
  styleUrls: ['./aya-school-table.component.scss', './print-aya-school-table.component.scss'],
})
export class AyaSchoolTableComponent {
  @Input() table: AyaSchoolTableView | undefined;
}
